module.exports = __webpack_public_path__ + "img/slide14.31cac411.png";